import { Organization } from '@/interfaces/Organization'

export enum UserProfileRole {
  AllBranches = 'ROLE.BRANCHES_ALL',
  AllDeals = 'ROLE.DEALS_ALL',
  AllEstimates = 'ROLE.ESTIMATES_ALL',
  AllLeads = 'ROLE.LEADS_ALL',
  AllMessages = 'ROLE.MESSAGES_ALL',
  AllReservations = 'ROLE.RESERVATIONS_ALL',
  ApproveSaleNotes = 'ROLE.SALE_NOTES_APPROVE',
  DealershipCashFlows = 'ROLE.DEALERSHIP_CASHFLOWS',
  DealershipProducts = 'ROLE.DEALERSHIP_PRODUCTS',
  DealershipReports = 'ROLE.DEALERSHIP_REPORTS',
  AdvancedDealershipReports = 'ROLE.DEALERSHIP_REPORTS_ADVANCED',
  DealershipStockReport = 'ROLE.DEALERSHIP_REPORTS_STOCK',
  EditClients = 'ROLE.CLIENTS_EDIT',
  EditConsignments = 'ROLE.CONSIGNMENTS_EDIT',
  EditDocumentTemplates = 'ROLE.DOCUMENTS_TEMPLATES_EDIT',
  EditProfiles = 'ROLE.PROFILES_EDIT',
  EditPromissoryNotes = 'ROLE.PROMISSORY_NOTES_EDIT',
  EditPurchases = 'ROLE.PURCHASES_EDIT',
  EditSaleNotes = 'ROLE.SALE_NOTES_EDIT',
  EditSettlements = 'ROLE.SETTLEMENTS_EDIT',
  EditVehicles = 'ROLE.VEHICLES_EDIT',
  ModifyVehiclePrice = 'ROLE.VEHICLES_MODIFY_PRICE',
  ArchiveVehicles = 'ROLE.VEHICLES_ARCHIVE',
  ModifyPurchases = 'ROLE.PURCHASES_MODIFY',
  ModifySaleNotes = 'ROLE.SALE_NOTES_MODIFY',
  ReassignSaleNotes = 'ROLE.SALE_NOTES_REASSIGN',
  ModifySettlements = 'ROLE.SETTLEMENTS_MODIFY',
  OwnDeals = 'ROLE.DEALS_OWN',
  OwnEstimates = 'ROLE.ESTIMATES_OWN',
  OwnLeads = 'ROLE.LEADS_OWN',
  OwnReservations = 'ROLE.RESERVATIONS_OWN',
  PublishExternal = 'ROLE.EXTERNAL_PUBLISH',
  ManageExternalProducts = 'ROLE.EXTERNAL_PRODUCTS',
  ControlSaleNotes = 'ROLE.SALENOTES_CONTROL',
  ViewClients = 'ROLE.CLIENTS_VIEW',
  ViewProfiles = 'ROLE.PROFILES_VIEW',
  ViewPromissoryNotes = 'ROLE.PROMISSORY_NOTES_VIEW',
  ViewPurchasesPrice = 'ROLE.PURCHASES_VIEW_PRICE',
  ViewVehicles = 'ROLE.VEHICLES_VIEW',
  VoidConsignments = 'ROLE.CONSIGNMENTS_VOID',
  VoidPromissoryNotes = 'ROLE.PROMISSORY_NOTES_VOID',
  VoidPurchases = 'ROLE.PURCHASES_VOID',
  VoidSaleNotes = 'ROLE.SALE_NOTES_VOID',
  VoidSettlements = 'ROLE.SETTLEMENTS_VOID',
  EditTransfers = 'ROLE.TRANSFERS_EDIT',
  ViewTransfers = 'ROLE.TRANSFERS_VIEW',
}

export enum UserProfileJob {
  SalesRep = 'JOB.SALESREP',
  Manager = 'JOB.MANAGER',
  Seller = 'JOB.SELLER',
  Owner = 'JOB.OWNER',
}

export interface UserProfile {
  _id: string
  roles: UserProfileRole[]
  organization: string
  job: UserProfileJob
  email: string
  body: {
    organization: Organization
  }
}
